/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BonusBatchGrantCreateReqVo
 */
export interface BonusBatchGrantCreateReqVo {
    /**
     * 用户ID列表（前端赔偿会员目录的最终名单，后端自动去重）
     * @type {Array<number>}
     * @memberof BonusBatchGrantCreateReqVo
     */
    userIds: Array<number>;
    /**
     * 发放方式：1-一次性，2-分批
     * @type {number}
     * @memberof BonusBatchGrantCreateReqVo
     */
    grantWay: number;
    /**
     * 每人发放总额
     * @type {number}
     * @memberof BonusBatchGrantCreateReqVo
     */
    amount: number;
    /**
     * 每次发放金额（分批时必填，≤每人总额；一次性时忽略）
     * @type {number}
     * @memberof BonusBatchGrantCreateReqVo
     */
    perGrantAmount?: number;
    /**
     * 间隔类型：1-按月（每月X号），2-按天（每隔N天）；分批时必填
     * @type {number}
     * @memberof BonusBatchGrantCreateReqVo
     */
    intervalType?: number;
    /**
     * 每月几号发放（intervalType=1时必填，1-31；当月无该日期按当月最后一天）
     * @type {number}
     * @memberof BonusBatchGrantCreateReqVo
     */
    dayOfMonth?: number;
    /**
     * 间隔天数（intervalType=2时必填，≥1）
     * @type {number}
     * @memberof BonusBatchGrantCreateReqVo
     */
    intervalDays?: number;
    /**
     * 发放说明（附加在每人流水自动文案后）
     * @type {string}
     * @memberof BonusBatchGrantCreateReqVo
     */
    remark?: string;
}

/**
 * Check if a given object implements the BonusBatchGrantCreateReqVo interface.
 */
export function instanceOfBonusBatchGrantCreateReqVo(value: object): value is BonusBatchGrantCreateReqVo {
    if (!('userIds' in value) || value['userIds'] === undefined) return false;
    if (!('grantWay' in value) || value['grantWay'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function BonusBatchGrantCreateReqVoFromJSON(json: any): BonusBatchGrantCreateReqVo {
    return BonusBatchGrantCreateReqVoFromJSONTyped(json, false);
}

export function BonusBatchGrantCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusBatchGrantCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userIds': json['userIds'],
        'grantWay': json['grantWay'],
        'amount': json['amount'],
        'perGrantAmount': json['perGrantAmount'] == null ? undefined : json['perGrantAmount'],
        'intervalType': json['intervalType'] == null ? undefined : json['intervalType'],
        'dayOfMonth': json['dayOfMonth'] == null ? undefined : json['dayOfMonth'],
        'intervalDays': json['intervalDays'] == null ? undefined : json['intervalDays'],
        'remark': json['remark'] == null ? undefined : json['remark'],
    };
}

export function BonusBatchGrantCreateReqVoToJSON(json: any): BonusBatchGrantCreateReqVo {
    return BonusBatchGrantCreateReqVoToJSONTyped(json, false);
}

export function BonusBatchGrantCreateReqVoToJSONTyped(value?: BonusBatchGrantCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userIds': value['userIds'],
        'grantWay': value['grantWay'],
        'amount': value['amount'],
        'perGrantAmount': value['perGrantAmount'],
        'intervalType': value['intervalType'],
        'dayOfMonth': value['dayOfMonth'],
        'intervalDays': value['intervalDays'],
        'remark': value['remark'],
    };
}

